// extracted by mini-css-extract-plugin
module.exports = {"title":"EmptyNotification-module--title--10bzV","emptyNotification":"EmptyNotification-module--empty-notification--2tk5y"};